import { render, staticRenderFns } from "./sparePartClassify.vue?vue&type=template&id=66e3a4ca&scoped=true&"
import script from "./sparePartClassify.vue?vue&type=script&lang=js&"
export * from "./sparePartClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3a4ca",
  null
  
)

export default component.exports